var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1042.9 455",
    style: {
      enableBackground: "new 0 0 1042.9 455"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1D3C34;}\n\t.st1{fill:#B7DC8F;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#F6F8F1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640.3,151.9c6-14.4-0.9-30.9-15.3-36.9c-14.4-6-30.9,0.9-36.9,15.3l-71.6,172.8c-6,14.4,0.9,30.9,15.3,36.9 c14.4,6,30.9-0.9,36.9-15.3L640.3,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M732.5,151.9c-6-14.4,0.9-30.9,15.3-36.9s30.9,0.9,36.9,15.3l71.6,172.8c6,14.4-0.9,30.9-15.3,36.9 c-14.4,6-30.9-0.9-36.9-15.3L732.5,151.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M875.7,130.3c6-14.4,22.5-21.2,36.9-15.3s21.2,22.5,15.3,36.9l-24,57.9c-6,14.4-22.5,21.2-36.9,15.3 c-14.4-6-21.2-22.5-15.3-36.9L875.7,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M687.8,245.2c-6-14.4-22.5-21.2-36.9-15.3c-14.4,6-21.2,22.5-15.3,36.9l24,57.9c6,14.4,22.5,21.2,36.9,15.3 c14.4-6,21.2-22.5,15.3-36.9L687.8,245.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.9,171.1c0-16.7,12.1-30.3,28.1-30.3c8.4,0,15.4,4.3,18.6,9V142h12.8v58.2h-12.8v-7.8 c-3.3,4.7-10.2,9-18.6,9C125,201.4,112.9,187.8,112.9,171.1z M160.7,171.1c0-10.5-7.1-18.6-17.4-18.6s-17.4,8.2-17.4,18.6 c0,10.5,7.1,18.6,17.4,18.6S160.7,181.6,160.7,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182,189.1l9.4-6.8c2.3,5.1,8,8,14,8c4.5,0,8.4-2.1,8.4-6.2c0-3.4-2-5.2-9-7.5l-5.1-1.4 c-10.2-2.8-15.4-9.1-15.3-17.8c0-10.2,9.2-16.7,20.8-16.7c8.9,0,15.6,3.4,19.7,9.9l-8.9,6.8c-2.7-3.6-6.3-5.9-11.1-5.9 c-3.8,0-7.8,1.9-7.8,5.5c0,2.8,1.3,5.1,7,6.9l5.9,1.7c10.2,3.1,16.3,8,16.3,17.7c0,11.2-9.1,18.1-21.1,18.1 C195.1,201.4,186.2,197.5,182,189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.1,224.6V142h12.8v7.8c3.3-4.7,10.4-9,18.7-9c16,0,28.1,13.6,28.1,30.3s-12.1,30.3-28.1,30.3 c-8.4,0-15.5-4.3-18.7-9v32.1H237.1z M283.7,171.1c0-10.5-7.1-18.6-17.4-18.6c-10.4,0-17.5,8.2-17.5,18.6 c0,10.5,7.1,18.6,17.5,18.6C276.6,189.8,283.7,181.6,283.7,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307.5,112.9h12.8v87.3h-12.8V112.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.9,171.1c0-16.7,12.1-30.3,28.1-30.3c8.4,0,15.4,4.3,18.6,9V142h12.8v58.2h-12.8v-7.8 c-3.3,4.7-10.2,9-18.6,9C343,201.4,330.9,187.8,330.9,171.1z M378.7,171.1c0-10.5-7.1-18.6-17.4-18.6c-10.2,0-17.4,8.2-17.4,18.6 c0,10.5,7.1,18.6,17.4,18.6C371.6,189.8,378.7,181.6,378.7,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.8,142h12.8v7.9c3.6-5.9,10.1-9.1,17.7-9.1c13.5,0,22.2,9.5,22.2,24.3v35.1h-12.8v-33 c0-9.3-4.7-14.8-12.1-14.8c-8.5,0-15,6.5-15,19.1v28.6h-12.8V142z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.9,269h14.2l17.7,40.9l17.8-40.9H177l-26.4,58.2h-11.3L112.9,269z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M181.6,247.7c0-4.7,4-8.5,8.6-8.5c4.8,0,8.5,3.8,8.5,8.5c0,4.8-3.7,8.6-8.5,8.6 C185.6,256.3,181.6,252.4,181.6,247.7z M183.9,269h12.8v58.2h-12.8V269z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M207,298.1c0-16.7,12.1-30.3,28.1-30.3c8.4,0,15.4,4.3,18.6,9V269h12.8v58.2h-12.8v-7.8 c-3.3,4.7-10.2,9-18.6,9C219.1,328.4,207,314.7,207,298.1z M254.8,298.1c0-10.5-7.1-18.6-17.4-18.6s-17.4,8.2-17.4,18.6 c0,10.5,7.1,18.6,17.4,18.6S254.8,308.6,254.8,298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M293.7,299.1v28.1h-12.8v-87.3h12.8v51.2l22.2-22.1h16.2l-26,26l31.8,32.3h-16.4L293.7,299.1z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvLogo);
export default __webpack_public_path__ + "static/media/av_logo.c9f7eada360ae3046eb890b2095025df.svg";
export { ForwardRef as ReactComponent };